import * as utils from "@/utils";
import Vue from "vue";

describe("utils test", () => {
  beforeEach(() => {
    Vue.$log = {
      error: jest.fn()
    };
  });

  describe("getEnvironment", () => {
    const adobeLaunchProd =
      "//assets.adobedtm.com/95c3e405673d/81c80ecf6aaf/launch-144c155dcd64.min.js";
    const adobeLaunchDevelopment =
      "//assets.adobedtm.com/95c3e405673d/81c80ecf6aaf/launch-8bd807155300-development.min.js";

    const mockHostname = hostname => {
      delete window.location;
      window.location = { hostname, href: `https://${hostname}/` };
    };

    it("should return PROD launch URL for BBVA production hosts", () => {
      mockHostname("apps.bbva.com.ar");

      expect(utils.getEnvironment()).toEqual({
        name: "prod",
        description: "Produccion",
        adobeLaunch: adobeLaunchProd
      });
    });

    it("should return development launch URL for TEST hosts", () => {
      mockHostname("app-work.bbva.com.ar");

      expect(utils.getEnvironment()).toEqual({
        name: "qa",
        description: "Test",
        adobeLaunch: adobeLaunchDevelopment
      });
    });

    it("should return development launch URL as fallback for unknown hosts", () => {
      mockHostname("localhost");

      expect(utils.getEnvironment()).toEqual({
        name: "de",
        description: "Desarrollo",
        adobeLaunch: adobeLaunchDevelopment
      });
    });
  });

  describe("cuilGen", () => {
    it("cuilGen -> should generate the correct CUIL for a company", () => {
      let numeroDocumento = "98765432";
      let sexo = "SOCIEDAD";
      let expectedCUIL = "30987654321";

      let result = utils.cuilGen(numeroDocumento, sexo);

      expect(result).toBe(expectedCUIL);
    });

    it("cuilGen -> function should generate correct cuil for female", () => {
      const cuil = utils.cuilGen("2345678", "MUJER");
      expect(cuil).toEqual("27023456783");
    });

    it("cuilGen -> function should generate correct cuil for male", () => {
      const cuil = utils.cuilGen("12345678", "HOMBRE");
      expect(cuil).toEqual("20123456786");
    });

    it("cuilGen -> function should return empty when numeroDocumento isNaN", () => {
      const cuil = utils.cuilGen("numeroDoc", "HOMBRE");
      expect(cuil).toEqual("");
    });
  });

  describe("isValidCuil", () => {
    it("isValidCuil -> function should return false when cuil is null", () => {
      const isValid = utils.isValidCuil(null);
      expect(isValid).toBe(false);
    });

    it("isValidCuil -> function should return false when cuil is not number", () => {
      const isValid = utils.isValidCuil("abc12345");
      expect(isValid).toBe(false);
    });

    it("isValidCuil -> deberia retornar false cuando cuil tiene distinto de 11 digitos", () => {
      const isValid = utils.isValidCuil(271234567891);
      expect(isValid).toBe(false);
    });

    it("isValidCuil -> deberia retornar false cuando cuil tiene formato invalido", () => {
      const isValid = utils.isValidCuil(20123456787);
      expect(isValid).toBe(false);
    });

    it("isValidCuil -> deberia retornar true cuando formato de cuil es valido", () => {
      const isValid = utils.isValidCuil(20123456786);
      expect(isValid).toBe(true);
    });
  });

  it("formattedFacturation -> function should remove non-digit characters", () => {
    const input = { a: "123abc", b: "456def" };
    const output = utils.formattedFacturation(input);
    expect(output).toEqual({ a: "123", b: "456" });
  });

  it("replaceAll -> function should replace all occurrences correctly", () => {
    const str = utils.replaceAll("abcabcabc", "a", "z");
    expect(str).toEqual("zbczbczbc");
  });

  describe("isDev", () => {
    it("should return true when environment is set to development", () => {
      if (process.env.NODE_ENV !== "production") {
        expect(utils.isDev()).toBe(true);
      } else {
        expect(utils.isDev()).toBe(false);
      }
    });
  });

  describe("getParameterByName", () => {
    it("should return the value of the specified parameter from the URL", () => {
      const url = "https://example.com/?name=John&age=30";
      const name = "name";
      const expectedMock = "John";
      const result = utils.getParameterByName(name, url);
      expect(result).toEqual(expectedMock);
    });
    it("should return null value when not exists parameters", () => {
      const url = "https://example.com/";
      const name = "name";
      const result = utils.getParameterByName(name, url);
      expect(result).toBeNull();
    });
    it("should return empty value of the specified parameter from the URL with name", () => {
      const url = "https://example.com/?name=John&age=30&address=";
      const name = "address";
      const expectedMock = "";
      const result = utils.getParameterByName(name, url);
      expect(result).toEqual(expectedMock);
    });
    it("should return empty value of the specified parameter from the URL empty", () => {
      const url = "";
      const name = "address";
      const result = utils.getParameterByName(name, url);
      expect(result).toBeNull();
    });
  });

  describe("getTrackingCodeLocal", () => {
    beforeEach(() => {
      delete window.location;
      window.location = {
        href:
          "https://example.com/?track=UnTrack&origen=UnOrigen&cid=Un:tracking:viejo:de:Cid"
      };
    });

    it("tracking code for the specified name", () => {
      expect(utils.getTrackingCodeLocal("John")).toBe(null);
    });
    it("tracking code empty", () => {
      expect(utils.obtenerTrackingCode()).toMatch("");
    });
    it("should return the tracking code for the specified name", () => {
      expect(utils.getTrackingCodeLocal("track")).toBe("UnTrack");
    });
    it("should return the tracking code for the specified name out params", () => {
      expect(utils.obtenerTrackingCode()).toBe("-Un-tracking-viejo-de");
    });
    it("should return other tracking code for the out params", () => {
      delete window.location;
      window.location = {
        href: "https://example.com/?onsite=esto-es-un-valor-nuevo"
      };
      expect(utils.obtenerTrackingCode()).toBe("-esto-es-un-valor");
    });

    afterAll(() => {
      window.location.href = "";
    });
  });

  describe("toTitleCase", () => {
    it("should convert a string to title case", () => {
      const str = "hello, world!";
      const expectedMock = "Hello, World!";
      const result = utils.toTitleCase(str);
      expect(result).toEqual(expectedMock);
    });
    it("should convert an empty string to an empty string", () => {
      const str = "";
      const expectedMock = "";
      const result = utils.toTitleCase(str);
      expect(result).toEqual(expectedMock);
    });
    it("should convert a string with multiple words to title case", () => {
      const str = "this is a test";
      const expectedMock = "This Is A Test";
      const result = utils.toTitleCase(str);
      expect(result).toEqual(expectedMock);
    });
  });

  describe("isValidDate", () => {
    it("should return true for a valid date string", () => {
      expect(utils.isValidDate("01/01/2024")).toBe(true);
    });
    it("should return false for an invalid date string", () => {
      expect(utils.isValidDate("30/02/2024")).toBe(false);
    });
    it("should return false for an empty date string", () => {
      expect(utils.isValidDate("")).toBe(false);
    });
    it("should return false for stone age", () => {
      expect(utils.isValidDate("01/01/4000")).toBe(false);
    });
  });

  describe("countSteps function", () => {
    it("should return the correct count of steps", () => {
      const steps = [
        { paso: true },
        { paso: false },
        { paso: true },
        { paso: 0 },
        { paso: "some value" }
      ];
      const count = utils.countSteps(steps);
      expect(count).toBe(3);
    });

    it("should return 0 when there are no steps", () => {
      const steps = [];
      const count = utils.countSteps(steps);
      expect(count).toBe(0);
    });

    it("should return 0 when there are no truthy steps", () => {
      const steps = [
        { paso: false },
        { paso: 0 },
        { paso: null },
        { paso: undefined }
      ];
      const count = utils.countSteps(steps);
      expect(count).toBe(0);
    });
  });

  describe("formatMoney function", () => {
    it("should correctly format integer amounts", () => {
      const result = utils.formatMoney("1234567");
      expect(result).toBe("1.234.567");
    });

    it("should handle amounts without integer part", () => {
      const result = utils.formatMoney("0.89");
      expect(result).toBe("0.89");
    });

    it("should handle amounts with less than 4 digits", () => {
      const result = utils.formatMoney("123");
      expect(result).toBe("123");
    });

    it("should handle empty strings", () => {
      const result = utils.formatMoney("");
      expect(result).toBe("");
    });

    it("should handle non-numeric strings", () => {
      const result = utils.formatMoney("abc");
      expect(result).toBe("abc");
    });

    it("should handle null", () => {
      const result = utils.formatMoney(null);
      expect(result).toBe(null);
    });
  });
});
